<template>
<div class="container">
    <div class="staticBar rounded">
        <div :style="{ 'width': `${secureData}%` }" class="dinamicBar rounded"></div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'SalesBar',

        props: ['data'],

        methods: {
            modData() {
               return this.data > 100 ? this.secureData = 100 : this.secureData = this.data
            }
        },

        watch: {
            data () {
                this.modData()
            }
        },

        created() {
            this.modData()
        },

        data() {
            return {
                secureData: 0
            }
        }
    }
</script>

<style scoped>

.container {
    width: 95%;
    margin: 0 auto
}

.dinamicBar{
    background-color: rgb(31, 215, 215);
    position: absolute;
    width: 100%;
    height: 5px;
    top: 0;
}

.staticBar {
    background-color: rgba(31, 215, 215,.32);
    position: relative;
    width: 100%;
    height: 5px;
}

</style>